const initialState = {
  isFirstVisited: false,
  isUserDataCollected: false
}

export const settingsReducer = (
  state = initialState,
  action: { type: string }
) => {
  switch (action.type) {
    case 'ACTION_IS_FIRST_VISITED':
      return {
        ...state,
        isFirstVisited: true
      };
    case 'ACTION_IS_USER_DATA_COLLECTED':
      return {
        ...state,
        isUserDataCollected: true
      }
    default:
      return state;
  }
}

export const toggleIsFirstVisitedAction = () => ({
  type: 'ACTION_IS_FIRST_VISITED',
});

export const toggleUserDataCollected = () => ({
  type: 'ACTION_IS_USER_DATA_COLLECTED'
})